module.exports = __webpack_public_path__ + "static/media/HL17.098d1eb1.jpg";